module.exports = __webpack_public_path__ + "static/media/Mediakit.52563401.png";